import * as THREE from 'three/build/three.module';
import { MaterialType} from './J3TypeList';
//import { MaterialProperty } from './J3TypeList';


export class J3MaterialMaker extends EventTarget{
    constructor() {
        super();
    }

    SetMaterial(type:MaterialType, material:THREE.Material, prop){
        switch (type){
            case 'basic':
                material = new THREE.MeshBasicMaterial(prop);
                break;
            case 'normal':
                material = new THREE.MeshNormalMaterial(prop);
                break;
            case 'lambert':
                material = new THREE.MeshLambertMaterial(prop);
                break;
            case 'phong':
                material = new THREE.MeshPhongMaterial(prop);
                break;
            case 'toon':
                material = new THREE.MeshToonMaterial(prop);
                break;
            case 'standard':
                material = new THREE.MeshStandardMaterial(prop);
                break;
            case 'linebasic':
                material = new THREE.LineBasicMaterial(prop);
                break;
            case 'linebasic':
                material = new THREE.LineDashedMaterial(prop);
                break;
            case 'points':
                //prop.blending = THREE.AdditiveBlending;
                console.log('J3MaterialMaker: PointsMaterial');
                material = new THREE.PointsMaterial(prop);
                break;
            default:
                console.log('J3MaterialMaker: type not found. default material applied');
                material = new THREE.MeshBasicMaterial(prop);
                break;
        }
        return material;
    }

    MakeMaterial(type:MaterialType, addTexture:boolean=false, image:string = null, prop):THREE.Material{
        // typeで作成するマテリアルを変える
        let material:THREE.Material = null;
        if(addTexture){
            //テクスチャを付加する
            var textureLoader = new THREE.TextureLoader();
            console.log('MakeMaterial image=',image);
            textureLoader.load(image, texture => {
                texture.encoding = THREE.sRGBEncoding;
                prop.map = texture;
                material = this.SetMaterial(type, material, prop);
                const event = new CustomEvent('MaterialSet', { detail: {material:material} });
                this.dispatchEvent(event);
            });
        }else{
            //テクスチャなし
            prop.map = null;
            material = this.SetMaterial(type, material, prop);
            const event = new CustomEvent('MaterialSet', { detail: {material:material} });
            this.dispatchEvent(event);
        }
    }
}